"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstantiationTrace = exports.disableInstantiationTrace = exports.enableInstantiationTrace = void 0;
/* eslint-disable no-shadow */
var service_identifier_1 = require("./service-identifier");
var _enableTracing = false;
// 开启依赖注入初始化日志
function enableInstantiationTrace() {
    _enableTracing = true;
}
exports.enableInstantiationTrace = enableInstantiationTrace;
// 关闭依赖注入实例化日志
function disableInstantiationTrace() {
    _enableTracing = false;
}
exports.disableInstantiationTrace = disableInstantiationTrace;
/**
 * 用于依赖注入框架注入模块时的日志跟踪，对日常开发调试非常有用
 */
var InstantiationTrace = /** @class */ (function () {
    function InstantiationTrace(type, name) {
        this.type = type;
        this.name = name;
        this._start = Date.now();
        this._dep = [];
    }
    /**
     * 跟踪依赖注入框架的invoke调用
     * @param ctor 构造函数
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    InstantiationTrace.traceInvocation = function (ctor) {
        return !_enableTracing
            ? InstantiationTrace._None
            : new InstantiationTrace(1 /* Invocation */, ctor.name || ctor.toString().substring(0, 42).replace(/\n/g, ''));
    };
    /**
     * 跟踪依赖注入框架的create调用
     * @param ctor 构造函数
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    InstantiationTrace.traceCreation = function (ctor) {
        return !_enableTracing
            ? InstantiationTrace._None
            : new InstantiationTrace(0 /* Creation */, ctor.name);
    };
    /**
     * 遍历日志，生成层级化结构
     * @param trace 日志对象
     * @param serviceId 服务ID
     * @param created 是否为create调用
    */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    InstantiationTrace.traverse = function (trace, serviceId, created) {
        if (created === void 0) { created = false; }
        if (!_enableTracing) {
            return created;
        }
        var isCreated = created;
        // 遍历trace日志的依赖关系
        trace === null || trace === void 0 ? void 0 : trace._dep.forEach(function (depItem, idx) {
            var _a = __read(depItem, 3), id = _a[0], first = _a[1], child = _a[2];
            if (id === serviceId) {
                if (isCreated === true && first === true) {
                    trace._dep[idx] = [
                        id,
                        false,
                        new InstantiationTrace(2 /* Branch */, id.toString()),
                    ];
                }
                else {
                    isCreated = true;
                    if ((child === null || child === void 0 ? void 0 : child._dep) && (child === null || child === void 0 ? void 0 : child._dep.length) > 0) {
                        isCreated = InstantiationTrace.traverse(child, serviceId, isCreated);
                    }
                }
            }
            else if ((child === null || child === void 0 ? void 0 : child._dep) && (child === null || child === void 0 ? void 0 : child._dep.length) > 0) {
                isCreated = InstantiationTrace.traverse(child, serviceId, isCreated);
            }
        });
        return isCreated;
    };
    /**
     * 新建一层日志Trace，组成树形结构
     * @param id
     * @param first
     */
    InstantiationTrace.prototype.branch = function (id, first) {
        var child = new InstantiationTrace(2 /* Branch */, id.toString());
        this._dep.push([id, first, child]);
        return child;
    };
    // 结束日志的trace过程，输出日志
    InstantiationTrace.prototype.stop = function () {
        var dur = Date.now() - this._start;
        InstantiationTrace._totals += dur;
        var causedCreation = false;
        // 递归遍历日志树，使用\t符输出层级结构
        function printChild(n, trace) {
            var e_1, _a;
            var res = [];
            var prefix = new Array(n + 1).join('\t');
            try {
                for (var _b = __values(trace._dep), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 3), id = _d[0], first = _d[1], child = _d[2];
                    if (first && child) {
                        causedCreation = true;
                        res.push(prefix + "CREATES -> " + service_identifier_1.getIdentifierName(id));
                        var nested = printChild(n + 1, child);
                        if (nested) {
                            res.push(nested);
                        }
                    }
                    else {
                        res.push(prefix + "uses -> " + service_identifier_1.getIdentifierName(id));
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return res.join('\n');
        }
        var lines = [
            (this.type === 0 /* Creation */ ? 'CREATE' : 'CALL') + " " + this.name,
            "" + printChild(1, this),
            "DONE, took " + dur.toFixed(2) + "ms (grand total " + InstantiationTrace._totals.toFixed(2) + "ms)",
        ];
        if (dur > 2 || causedCreation) {
            console.log(lines.join('\n'));
        }
    };
    InstantiationTrace._None = new (/** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super.call(this, -1, null) || this;
        }
        class_1.prototype.stop = function () { };
        class_1.prototype.branch = function () {
            return this;
        };
        return class_1;
    }(InstantiationTrace)))();
    InstantiationTrace._totals = 0;
    return InstantiationTrace;
}());
exports.InstantiationTrace = InstantiationTrace;
//# sourceMappingURL=instantiation-trace.js.map